import { EmailOutlined } from "@mui/icons-material";
import {
  Box,
  Button,
  Divider,
  Grid2,
  InputAdornment,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { lightPalette } from "../../theme-layout/palette";
import { Link as RouterLink } from "react-router-dom";
import { useState } from "react";
import urlConstant from "../../constants/urlConstants";
import apiClient from "../../lib/api";
import { trackPromise } from "react-promise-tracker";
import SnackState from "../../shared-components/snackbar/snackState";
import CommonSnackBar from "../../shared-components/snackbar/commonSnackbar";

const ForgotPasswordPage = () => {
  const [emailSent, setEmailSent] = useState(false);
  const [snack, closeSnack, showSnackbar] = SnackState();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: { email: "" } });
  const onSubmit = async (data) => {
    const requestObject = {
      email: data.email,
    };

    trackPromise(
      apiClient
        .post(urlConstant.Login.ForgotPassword, requestObject, {
          authRequired: true,
        })
        .then((response) => {
          if (response?.status === "Success" && response?.statusCode === 200) {
            setEmailSent(true);
          } else {
            setEmailSent(false);
            showSnackbar(response?.message, "error");
          }
        })
        .catch((err) => {
          showSnackbar(err.message, "error");
        })
    );
  };

  return (
    <>
      <Grid2 container sx={{ minHeight: "100vh" }}>
        {/* Left side */}

        <Grid2
          item
          size={{ xs: 12, md: 7 }}
          px={{ md: 8, xs: 3 }}
          py={3}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems={{ xs: "center", md: "flex-start" }}
        >
          <Box
            maxWidth="520px"
            width="100%"
            textAlign={{ xs: "center", md: "left" }}
          >
            <img
              src="/Cambridge-Caregivers-Logo-2 1.svg"
              alt="Logo"
              className="camcare-logo-svg"
            />
            <Typography variant="h1" color="primary" mt={4}>
              {!emailSent ? "Forgot Your Password ?" : "Check your email"}
            </Typography>
            <Divider
              sx={{
                maxWidth: 36,
                borderWidth: 2,
                borderRadius: 4,
                backgroundColor: lightPalette.primary.main,
                mt: 0.5,
                mb: 1,
                mx: { xs: "auto", md: "0" },
              }}
            ></Divider>
            <Typography variant="h6" color="default" mb={3}>
              {!emailSent
                ? "Enter your registered email address, and we'll send you a link to reset your password."
                : "Password reset link has been sent to your registered email. Please check your inbox."}
            </Typography>
            {!emailSent ? (
              <form onSubmit={handleSubmit(onSubmit)} noValidate>
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email address",
                    },
                  }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Email"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      error={!!errors.email}
                      helperText={errors.email?.message}
                      slotProps={{
                        input: {
                          endAdornment: (
                            <InputAdornment position="end">
                              <EmailOutlined />
                            </InputAdornment>
                          ),
                        },
                      }}
                    />
                  )}
                />

                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{ borderRadius: 5, py: 1.5, marginTop: "15px" }}
                >
                  Submit
                </Button>
                <Box mt={1} textAlign={"center"}>
                  <Link component={RouterLink} to="/login" variant="body1">
                    Back to Login
                  </Link>
                </Box>
              </form>
            ) : (
              <Box mt={1} textAlign={"center"}>
                <Link component={RouterLink} to="/login" variant="body1">
                  Back to Login
                </Link>
              </Box>
            )}
          </Box>
        </Grid2>

        {/* Right side */}
        <Grid2
          item
          size={{ xs: 12, md: 5 }}
          display={{ xs: "none", md: "flex" }}
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          padding={4}
          sx={{
            backgroundColor: lightPalette.default.main,
          }}
        >
          <img
            src="/Nursing home-rafiki 1.svg"
            alt="Caregiver Illustration"
            className="camcare-illustration-svg"
          />
          <Typography variant="h3" mt={4} align="center" color="white">
            Welcome to
            <br />
            Cambridge Caregivers
          </Typography>
        </Grid2>
      </Grid2>
      <CommonSnackBar
        snackObj={snack}
        closeSnack={closeSnack}
        duration={2000}
      />
    </>
  );
};

export default ForgotPasswordPage;